exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._27xjp{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;padding:0 0 15px}._2IouA{display:inline-block;height:20px;line-height:19px;border-radius:2px;margin-right:6px;margin-bottom:10px;font-weight:400;font-size:12px;padding:0 5px;border:1px solid #c4c4c4;color:gray}@media screen and (max-width:768px){._27xjp{padding:10px 0 0}}", ""]);

// exports
exports.locals = {
	"statusList": "_27xjp",
	"statusItem": "_2IouA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/AdvertStatusList/AdvertStatusList.css
// module id = 2760
// module chunks = 32 36